<script>
/**
 * ****************************************************************************
 * @description     :   Select Component
 * @created at      :   2024/05/22
 * @created by      :   ANS903 – phuongdt@ans-asia.com
 * @package         :   Move
 * @copyright       :   Copyright (c) A.N.S Asia
 * @version         :   1.0.0
 * ****************************************************************************
 */
import _ from 'lodash';
/**
 * Import template
 */
import template from './template.html';
import helpers from '@/utils/helpers';
// import helpers from '@/utils/helpers';

/**
 * Define content of select component
 */
var PtjAnsSelect = {
    template: template,
    props: {
        id: String,
        label: String,
        name: String,
        itemClass: {
            type: [String, Object],
            default: ''
        },
        labelClass: String,
        inputClass: [String, Object],
        customizeSelectStyle: {
            type: [String, Object],
            default: ''
        },
        value: String | Number,
        modelValue: String | Number,
        emptyText: String,
        isRequired: Boolean,
        isDisabled: Boolean,
        isReadonly: Boolean,
        isMobile: {
            type: Boolean,
            default: false
        },
        isFromSearch: {
            type: Boolean,
            default: false
        },
        removeEmptyOption: {
            type: Boolean,
            default: false
        },
        options: Array,
        onChange: Function,
        onFocus: Function,
        onBlur: Function,
        keyValueOptions: {
            type: Array,
            default: ['code', 'name']
        },
        positionReferValue: {
            type: Number,
            default: 0
        },
        isTab: {
            type: Boolean,
            default: false
        },
        isHorizontal: {
            type: Boolean,
            default: false
        },
        widthLabel: {
            type: String,
            default: 'width-110-px'
        },
        errors: {
            type: Array
        },
        isAlwaysEnable: {
            type: Boolean,
            default: false
        },
        startZero: {
            type: Boolean,
            default: false
        },
        tabindex: {
            type: Number,
            default: 1
        }
    },
    emits: ['update:modelValue'],
    data() {
        return {
            modeDisabled: false,
            isFocus: false
        };
    },
    created() {
        if (
            ![
                'MNG_Order001',
                'MNG_Order004',
                'MNG_System002',
                'MNG_System004',
                'MNG_File001',
                'CUS_Order021',
                'CUS_Billing001',
                'CUS_Client003',
                'CUS_Delivery001'
            ].includes(this.$route.name)
        ) {
            this.modeDisabled = helpers.checkAuthorityMode(this.$route.name) && !this.isAlwaysEnable;
        }
    },
    computed: {
        vewValue() {
            const val = this.modelValue ? this.modelValue : this.value;
            return val;
        },
        checkRequired() {
            return this.vewValue == '' || this.vewValue == null || (!this.startZero ? this.vewValue == 0 : false);
        },
        listOptions() {
            const vm = this;
            if (!vm.removeEmptyOption) {
                if (!this.options) {
                    return [
                        {
                            [vm.keyValueOptions[0]]: '',
                            [vm.keyValueOptions[1]]: ''
                        }
                    ];
                }
                const idx = _.findIndex(this.options, function (o) {
                    return (
                        (o[vm.keyValueOptions[0]] === '' && o[vm.keyValueOptions[1]] === '') ||
                        o[vm.keyValueOptions[1]] === 'すべて' ||
                        o[vm.keyValueOptions[1]] === '全て'
                    );
                });
                if (idx < 0) {
                    this.options.unshift({
                        [vm.keyValueOptions[0]]: '',
                        [vm.keyValueOptions[1]]: ''
                    });
                }
            }
            return this.options;
        },
        wrapperClass() {
            const baseClasses = {
                'd-flex': true,
                'position-relative': true
            };
            return { ...baseClasses, ...this.itemClass };
        },
        selectClass() {
            const baseClasses = {
                'form-select': true,
                'custom-select': true,
                'h-26px': true,
                'rounded-025': true,
                gap: true,
                'font-size-12-px': true,
                'pad-style': true,
                required: this.isRequired,
                'required-focus': this.isRequired && this.isFocus,
                removebg: this.isMobile && this.vewValue,
                'bg-white': !this.checkRequired,
                'border-1': true
            };

            // Handle inputClass as object or string
            if (typeof this.inputClass === 'object' && this.inputClass !== null) {
                return { ...baseClasses, ...this.inputClass };
            } else if (typeof this.inputClass === 'string' && this.inputClass) {
                return { ...baseClasses, [this.inputClass]: true };
            }

            return baseClasses;
        },
        selectStyle() {
            let styles = [];
            styles.push(this.customizeSelectStyle);

            return styles;
        }
    },
    methods: {
        /**
         * event forcus on select element
         * -----------------------------------------
         * @author : PhuongDT - 2024/05/22 - create
         * @params :
         * @access : private
         */
        focusInput(e) {
            this.isFocus = true;
            if (this.onFocus) {
                this.onFocus(e);
            }
        },
        /**
         * event forcus on select element
         * -----------------------------------------
         * @author : PhuongDT - 2024/05/22 - create
         * @params :
         * @access : private
         */
        focusItem() {
            this.$refs.select.focus();
        },
        /**
         * event blur on select element
         * -----------------------------------------
         * @author : PhuongDT - 2024/05/22 - create
         * @params :
         * @access : private
         */
        blurInput(e) {
            this.isFocus = false;
            if (this.onBlur) {
                this.onBlur(e);
            }
        },
        /**
         * click update item for select element
         * -----------------------------------------
         * @author : PhuongDT - 2024/05/22 - create
         * @params :
         * @access : private
         */
        updateInput(e) {
            const vewValue = this.$refs.select.value;
            this.$emit('update:modelValue', vewValue);
            if (vewValue != '') {
                e.target.classList.remove('require-input');
            }
            if (this.onChange) {
                this.onChange(e, vewValue);
            }
        }
    }
};
export default PtjAnsSelect;
</script>
